<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class=" d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fas fa-exclamation-circle text-danger"></i> Complaint</h5>
      </div>
      <hr>
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">Title<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Title">
        </div>
        <div class="col-md-3">
          <label class="form-label">Name<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Name">
        </div>
        <div class="col-md-3">
          <label class="form-label">Phone<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="number" class="form-control form-control-sm"  @input="limitDigits($event, 10, v => Obj.Phone = v)" v-model="Obj.Phone">
        </div>
        <div class="col-md-3">
          <label class="form-label">Type<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Type">
        </div>
        <div class="col-md-3">
          <label class="form-label" >Status<sup><span class="text-danger font-12">*</span></sup> :</label>
          <select v-model="Obj.status" class="form-select form-select-sm rounded cursor-pointer" role="button">
            <option selected=""></option>
            <option value="Open">Open </option>
             <option value="Closed">Closed </option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Description<sup><span class="text-danger font-12">*</span></sup> :</label>
          <textarea type="text" class="form-control form-control-sm" v-model="Obj.Description"></textarea>
        </div>
        <div class="col-md-12 text-end">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()"><i class="fa fa-save"></i> Save</button>
           <button type="button" class="btn btn-sm btn-soft-dark " @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
      </div>
      <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      <div class="row mt-3">
        <div class="col-sm-12 table-responsive">
          <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
         <DataTable  v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"   :actions="{  edit: handleEdit, delete: handleDelete }" />
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.Title" @delRecord="delRecord" @closeModal="delObj.Title = ''"></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import { curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
import { useStore } from 'vuex' 
const store = useStore() 
const userId = store.state.userID;
  const  Obj = ref( { Title: "", Name: "", Phone: "", Description: "", Type: "",status:"", UserID: "", })
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   delObj = ref({})
    const   errors= ref({})
const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Title', key: 'Title' },
  { label: 'Name', key: 'Name' },
  { label: 'Phone', key: 'Phone' },
  { label: 'Description', key: 'Description', truncatable: true },
  { label: 'Type', key: 'Type' },
  { label: 'Status', key: 'status' , type: 'complaint-badge'}
]);

const handleEdit = (row) => {
    Obj.value = { ...row }
}
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const rows=ref([])
  const limitDigits = (event, max, assignFn) => {
  let val = event.target.value.toString().slice(0, max);
  assignFn(val.replace(/\D/g, ''));
}
const save = async () => {
  const fields = {
    Title: { value: Obj.value.Title, validators: [isRequired] },
    Name: { value: Obj.value.Name, validators: [isRequired] },
    Phone: { value: Obj.value.Phone, validators: [ (v) => { if (!v) return "Phone No. is required"; if (v.length < 10) return "Phone No. must be 10 digits"; return null; }, ], },
    Type: { value: Obj.value.Type, validators: [isRequired] },
    Status: { value: Obj.value.status, validators: [isRequired] },
    Description: { value: Obj.value.Description, validators: [isRequired] },
  };

  errors.value = validateForm(fields);
  if (Object.keys(errors.value).length === 0) {
    if (!Obj.value._id) {
      Obj.value.UserID = userId; 
    }
    const { url, method, msg } = curdStatus(Obj.value);
    await api[method](`/Complaint${url}`, Obj.value)
      .then(() => {
        loadData();
        reset();
        msgObj.value = {
          msg: `Complaint ${msg} Successfully`,
          role: "success",
          show: true,
        };
      })
      .catch((error) => {
        console.log(error);
      });
  }
};
   const reset =async () => {
      Obj.value = { Title: "", Name: "", Phone: "", Description: "", Type: "",status:"", UserID: "", };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value={};
    }
      const progress = ref(0)
 const loadData = async () => {
  let direction = 1;
  let progressInterval = setInterval(() => {
    progress.value += direction;
    if (progress.value >= 100) {
      progress.value = 0;
    }
  }, 100);

  await api
    .get(`/Complaint/search`)
    .then((response) => {
      const complaints = response.data.filter(item => item.active === true);
      rows.value = complaints.map((item, i) => ({ ...item, Sno: i + 1 }));

      progress.value = 0;
      clearInterval(progressInterval);
    })
    .catch((err) => {
      console.error("Error loading complaints:", err);
      clearInterval(progressInterval);
      progress.value = 0;
    });
};

   const delRecord =async () =>{
      await api.delete(`/Complaint/${delObj.value._id}`)
        .then(() => {
          loadData();
          delObj.value={};
          msgObj.value = { msg: "Complaint Deleted Successfuly.", role: "danger", show: true, };
        });
    }
     onMounted(() => { loadData() })
</script>